<template>
  <div class="pb-5">
    <product-logo v-if="isIAProduct" :name="`ia_dealer_services_${$i18n.locale}`" />
    <product-logo v-else-if="isAutoShieldProduct" :name="`auto-shield_logo`" />
    <product-logo v-else-if="isGlobalWarrantyProduct" :name="`global-warranty_logo`" />
    <product-logo v-else :name="product.internalName" />
    <slot></slot>
  </div>
</template>

<script>
const ProductLogo = () => import('@/modules/spotlight/containers/ProductLogo.vue');

export default {
  name: 'ProtectionBaseWithVendorLogo',
  components: {
    ProductLogo,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isIAProduct() {
      return this.product.internalName.includes('ia_');
    },
    isAutoShieldProduct() {
      return this.product.internalName.includes('auto-shield_');
    },
    isGlobalWarrantyProduct() {
      return this.product.internalName.includes('global-warranty_');
    },
  },
};
</script>

<style scoped></style>
